/**************************************************
 * Nombre:       Casilla_Titulo_Datos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, TableCell, Typography} from "@mui/material";
import {COLORTEXTO} from "../../../Constantes";
import {formatoFechaTabla} from "../../../Utilidades/formatoFechaTabla";

const Casilla_Titulo_Datos = ({titulo, datos, propiedades = [], dir, index}) => {

    return (
        <TableCell key={`${index}e4945`} variant={'body'} align={dir}
                   sx={{color: COLORTEXTO, fontWeight: 600, fontSize: 14, minWidth: 160}}>
            <Grid container size={12} alignItems={'center'}>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Typography sx={{fontSize: 12}}>
                            {titulo}
                        </Typography>
                    </Grid>
                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <Typography sx={{fontSize: 14, fontWeight: 600}}>
                            {propiedades.map((it, index) => {
                                return (
                                    <span>{`${datos[it]}  `}</span>
                                )
                            })}
                        </Typography>
                    </Grid>
                </Grid>

            </Grid>

        </TableCell>

    )

}
export default Casilla_Titulo_Datos